module.exports = __webpack_public_path__ + "img/ibc-international-bio-cosmetics-product-hair-1.2979741e.png";